import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { useDeletePriorityInviteMutation, useGetPriorityInviteCountQuery, useGetPriorityInvitesQuery, useResendPriorityInviteMutation } from "../../graphql/graphql";
import { calculateOffset, PriorityInvitesEmptyState, showErrorNotification, showSuccessNotification, TablePagination } from "../../shared/Internal";
import { PriorityInviteRow } from "./PriorityInviteRow";
import { ManagedTable } from "../../shared/ManagedTable";
export const PriorityInviteView = ({ search = "", isActiveTab, onModalOpen }) => {
    // State
    const [page, setPage] = useState(1);
    // Effects
    useEffect(() => {
        setPage(1);
    }, [search]);
    // Queries
    const [{ data, fetching }] = useGetPriorityInvitesQuery({
        requestPolicy: "cache-and-network",
        variables: {
            search,
            offset: calculateOffset(page)
        },
        pause: isActiveTab === false
    });
    const priorityInvites = data?.priorityInvites?.priorityInvites ?? [];
    // Get the priority invite count.
    const [{ data: countData }] = useGetPriorityInviteCountQuery({
        variables: {
            search
        },
        pause: isActiveTab === false
    });
    const count = countData?.priorityInvites?.priorityInviteCount ?? 0;
    // Mutations
    const [, resendPriorityInvite] = useResendPriorityInviteMutation();
    const [, deletePriorityInvite] = useDeletePriorityInviteMutation();
    // Handlers
    const handleResendInvite = async (priorityInviteId) => {
        if (!priorityInviteId)
            return;
        resendPriorityInvite({
            priorityInviteId
        }).then(({ error }) => {
            if (error) {
                showErrorNotification("An error occurred, the invite was not resent.");
            }
            else {
                showSuccessNotification("Invite resent!");
            }
        });
    };
    const handleDeleteInvite = async (priorityInviteId) => {
        if (!priorityInviteId)
            return;
        deletePriorityInvite({
            inviteId: priorityInviteId
        }).then(({ error }) => {
            if (error) {
                showErrorNotification("An error occurred, the invite was not deleted.");
            }
            else {
                showSuccessNotification("Invite deleted!");
            }
        });
    };
    /**
     * Create the table header
     */
    const tableHead = (_jsxs(Table.Tr, { children: [_jsx(Table.Th, { children: "Inviting User" }), _jsx(Table.Th, { children: "Email" }), _jsx(Table.Th, { children: "Status" }), _jsx(Table.Th, { style: { width: "150px" }, children: "Created At" }), _jsx(Table.Th, { style: { width: "50px" } })] }));
    // Priority Invite Rows
    const priorityInviteRows = useMemo(() => {
        return priorityInvites.map((priorityInvite) => {
            return (_jsx(PriorityInviteRow, { priorityInvite: priorityInvite, onResendInvite: () => handleResendInvite(priorityInvite?.priorityInviteId), onDeleteInvite: () => handleDeleteInvite(priorityInvite?.priorityInviteId) }, priorityInvite?.priorityInviteId));
        });
    }, [priorityInvites]);
    const caption = _jsx(TablePagination, { count: count, page: page, setPage: setPage });
    return (_jsx(ManagedTable, { withBorder: true, header: tableHead, rows: priorityInviteRows, caption: caption, minWidth: 800, fetching: fetching, emptyState: _jsx(PriorityInvitesEmptyState, { onModalOpen: onModalOpen }) }));
};
